import React from "react";
import Button from "../base/Button";
import FormControl from "../base/FormControl";
import uiPrefix from "../../utils/UiPrefixUtils";

export default function EmptyLibraryInstructions(props) {
  const { onAddFiles } = props;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "70%",
          height: "70%",
          border: "4px dashed rgba(255,255,255,0.2)",
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <h2 style={{ textAlign: "center", fontSize: 22, fontWeight: 300, marginBottom: 20 }}>
          Drag and drop files here or
        </h2>
        <div style={{ position: "relative" }}>
          <FormControl
            type="file"
            multiple
            onChange={onAddFiles}
            data-e2e={uiPrefix("file-upload-btn")}
            baseClassName={uiPrefix("file-upload-btn")}
          />
          <Button
            look="primary"
            data-e2e={uiPrefix("choose-files-btn")}
            className={uiPrefix("choose-files-btn")}
            style={{
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          >
            Choose Files to Upload
          </Button>
        </div>
      </div>
    </div>
  );
}
